import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Language, Utils } from "../../../utils";
import { user as userActions } from "../../../actions";
import { Button, ErrorIcon } from "../../../components";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import makeClasses from "../styles";
import clsx from "clsx";
import { InputLabel } from "@material-ui/core";

const StepThree = ({ traceId, nextStep }) => {
  const dispatch = useDispatch();
  const classes = makeClasses();

  const { loading, languageTexts } = useSelector((state) => ({
    loading: state.user.loading,
    languageTexts: state.language.texts || {},
  }));
  const i18n = Language(languageTexts);

  const [inputEmail, setInputEmail] = useState("");
  const [inputEmailConfirm, setInputEmailConfirm] = useState("");
  const [hasEmailError, setHasEmailError] = useState(false);
  const [hasEmailMismatchError, setHasEmailMismatchError] = useState(false);

  const canMoveNext =
    inputEmail.trim().length > 0 &&
    inputEmailConfirm.trim().length > 0 &&
    !hasEmailError &&
    !hasEmailMismatchError;

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setInputEmail(value);
    setHasEmailError(
      value.trim().length > 0 && !Utils.inputs.email.regex.test(value.trim()),
    );
    setHasEmailMismatchError(
      inputEmailConfirm.trim().length > 0 &&
        value.trim() !== inputEmailConfirm.trim(),
    );
  };

  const handleEmailConfirmChange = (e) => {
    const value = e.target.value;
    setInputEmailConfirm(value);
    setHasEmailMismatchError(value.trim() !== inputEmail.trim());
  };

  const handleSubmit = () => {
    const emailInvalid = !Utils.inputs.email.regex.test(inputEmail.trim());
    const mismatch = inputEmail.trim() !== inputEmailConfirm.trim();

    if (emailInvalid) setHasEmailError(true);
    if (mismatch) setHasEmailMismatchError(true);
    if (emailInvalid || mismatch) return;

    dispatch(
      userActions.affiliationRequestEmailVerificationCodeV2(
        traceId,
        inputEmail.trim(),
        (step2TraceId) => {
          if (step2TraceId !== false) {
            nextStep({
              email: inputEmail.trim(),
              affiliationStep2TraceId: step2TraceId,
            });
          }
        },
      ),
    );
  };

  return (
    <React.Fragment>
      <div className={classes.formContent}>
        <div className={classes.formTitleContainer}>
          <div className={classes.formTitle}>
            {i18n.get("Register.StepFormTitle")}
          </div>
          <div className={classes.formText}>
            {i18n.get("Register.Step3EmailFormText")}
          </div>
        </div>
        <form
          layout="vertical"
          onSubmit={handleSubmit}
          className={classes.form}>
          <Grid container spacing={2}>
            <Grid className={classes.inputWithErrorContainer} item xs={12}>
              <InputLabel className={classes.formSelectLabel}>
                {i18n.get("Register.InputEmailLabel")}
              </InputLabel>
              <TextField
                error={hasEmailError}
                placeholder={i18n.get("Register.InputEmailTitle")}
                className={classes.formInput}
                onChange={handleEmailChange}
                classes={{ root: classes.formInput }}
                variant="outlined"
                value={inputEmail}
                type="email"
                inputProps={{
                  autoComplete: "off",
                  onCopy: (e) => e.preventDefault(),
                  onPaste: (e) => e.preventDefault(),
                }}
              />
              {hasEmailError && (
                <div className={classes.errorMessageContainer}>
                  <ErrorIcon />
                  <div className={classes.errorMessage}>
                    {i18n.get("Register.EmailErrorMEssage")}
                  </div>
                </div>
              )}
            </Grid>
            <Grid className={classes.inputWithErrorContainer} item xs={12}>
              <InputLabel className={classes.formSelectLabel}>
                {i18n.get("Register.InputEmailConfirmLabel")}
              </InputLabel>
              <TextField
                error={hasEmailMismatchError}
                placeholder={i18n.get("Register.InputEmailConfirmTitle")}
                className={classes.formInput}
                onChange={handleEmailConfirmChange}
                classes={{ root: classes.formInput }}
                variant="outlined"
                value={inputEmailConfirm}
                type="email"
                inputProps={{
                  autoComplete: "off",
                  onCopy: (e) => e.preventDefault(),
                  onPaste: (e) => e.preventDefault(),
                }}
              />
              {hasEmailMismatchError && (
                <div className={classes.errorMessageContainer}>
                  <ErrorIcon />
                  <div className={classes.errorMessage}>
                    {i18n.get("Register.EmailMismatchErrorMessage")}
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </form>
      </div>
      <div
        className={clsx(
          classes.formSubmitContainer,
          classes.formSubmitContainerWithOneButton,
        )}>
        <Button
          className={classes.formSubmitButton}
          onClick={handleSubmit}
          disabled={loading || !canMoveNext}>
          {i18n.get("Register.NextButton")}
        </Button>
      </div>
    </React.Fragment>
  );
};

StepThree.id = "com.Handy.Register.StepThree";
export default StepThree;
